import { makeStyles } from 'tss-react/mui'

export default makeStyles()(theme => ({
  errorInline: {
    textTransform: 'none',
    color: 'rgb(244, 67, 54)',
    marginBottom: theme.spacing(2),
    position: 'absolute',
    maxWidth: 'calc(100% - 48px)',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    textAlign: 'left',
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },
  edit: {
    marginTop: theme.spacing(-2),
    marginLeft: theme.spacing(-1),
    marginBottom: theme.spacing(-2),
  },
}))
